var _defs, _rect, _rect2, _line, _line2, _line3, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedInPills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    width: 160,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lip-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1E3A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#172554"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "url(#lip-bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 34,
    width: 112,
    height: 62,
    rx: 8,
    fill: "#ffffff",
    opacity: 0.96
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 50,
    x2: 116,
    y2: 50,
    stroke: "#1E3A8A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.75
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 63,
    x2: 98,
    y2: 63,
    stroke: "#1E3A8A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.35
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 76,
    x2: 108,
    y2: 76,
    stroke: "#1E3A8A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.35
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 110,
    width: 42,
    height: 17,
    rx: 8.5,
    fill: "#EF4444"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 110,
    width: 30,
    height: 17,
    rx: 8.5,
    fill: "#FBBF24"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 110,
    width: 28,
    height: 17,
    rx: 8.5,
    fill: "#34D399"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInPills);
export default __webpack_public_path__ + "static/media/LinkedInPills.e00b5d4730b820d7f845b374654333c0.svg";
export { ForwardRef as ReactComponent };